import React from "react";
import { motion } from "framer-motion";
import { ABOUT, TEAM } from "../../data/content";
import RevealSection from "./RevealSection";

export default function QuiSom() {
  return (
    <RevealSection id="qui-som" className="px-5 py-24">
      <div className="mx-auto grid max-w-6xl gap-12 md:grid-cols-2 md:items-center">
        <div className="relative collage tone-cream p-8 md:p-10">
          <span className="font-hand text-2xl font-bold text-terracotta">{ABOUT.kicker.toLowerCase()} · la nostra història</span>
          <h2 className="mt-1 font-display text-4xl font-bold leading-tight text-forest sm:text-5xl">{ABOUT.title}</h2>
          {ABOUT.paragraphs.map((p, i) => (
            <p key={i} className="mt-4 font-body leading-relaxed text-forest/80">{p}</p>
          ))}
        </div>

        <div className="grid gap-7 sm:grid-cols-2">
          {TEAM.map((m, i) => (
            <motion.div
              key={m.id}
              initial={{ rotate: i % 2 ? 1.5 : -1.5 }}
              whileHover={{ y: -6, rotate: 0 }}
              transition={{ type: "spring", stiffness: 220, damping: 16 }}
              className={`relative p-5 pb-7 text-center ${i % 2 ? "collage collage-3 tone-kraft" : "collage collage-2 tone-white"}`}
              data-testid={`team-card-${m.id}`}
            >
              <div className="mx-auto mb-4 mt-2 flex h-24 w-24 items-center justify-center bg-sage paper-blob">
                <span className="font-display text-3xl font-bold text-paper">{m.name.split(" ").map((n) => n[0]).join("")}</span>
              </div>
              <h3 className="font-display text-xl font-semibold text-forest">{m.name}</h3>
              <p className="mt-1 font-hand text-lg font-bold text-forest">{m.role}</p>
              <p className="mt-3 font-body text-sm leading-relaxed text-forest/75">{m.text}</p>
            </motion.div>
          ))}
          <div className="relative sm:col-span-2 rounded-2xl border-2 border-dashed border-sage/40 bg-paper/40 p-4 text-center font-body text-sm font-semibold text-forest/70">
            Companyia de teatre artesanal · feta a mà i de proximitat
          </div>
        </div>
      </div>
    </RevealSection>
  );
}
